import { useState } from 'react';
import { MessageCircle, Instagram, X, Share2 } from 'lucide-react';
import { companyInfo } from '../mock';

const SocialButtons = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Vim pelo site e gostaria de solicitar um orçamento.');
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  const handleInstagramClick = () => {
    window.open('https://instagram.com/luvcorp_', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col-reverse items-end gap-3">
      {/* WhatsApp Button - Always visible or when expanded */}
      <button
        onClick={handleWhatsAppClick}
        className={`bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 group ${isOpen ? 'animate-fadeIn' : ''}`}
        aria-label="Falar no WhatsApp"
        data-testid="whatsapp-float-btn"
      >
        <MessageCircle size={28} />
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Fale no WhatsApp
        </span>
      </button>

      {/* Instagram Button */}
      <button
        onClick={handleInstagramClick}
        className="bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 hover:from-purple-700 hover:via-pink-600 hover:to-orange-500 text-white rounded-full p-4 shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-110 group"
        aria-label="Seguir no Instagram"
        data-testid="instagram-float-btn"
      >
        <Instagram size={28} />
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Siga-nos no Instagram
        </span>
      </button>
    </div>
  );
};

export default SocialButtons;
